import moment from "moment";
import CommonConfirmationProductSection from "../../components/common/CommonConfirmationProductSection.jsx";
import { configurations } from "../../../configurations.js";

function PackageConfirmationBookedTourSection({ booking }) {
  if (!booking) return <></>;

  return (
    <CommonConfirmationProductSection
      type={configurations.services.package.value}
      title={booking?.extraDetails?.productInfo?.title}
      items={[
        {
          label: "Order ID",
          value: booking?.mainBooking?.bookingId || booking?.bookingId,
          primary: true,
        },
        {
          label: "Order Date",
          value: moment(booking?.createdAt).format("DD/MM/YYYY HH:mm A"),
        },
        {
          label: "Start time",
          value: `${moment(booking?.startDate).format("DD MMM")} ${
            booking?.startDate
              ? `, ${moment(booking?.startDate, "HH:mm").format("h:mm A")}`
              : ""
          }`,
        },
      ]}
    />
  );
}

export default PackageConfirmationBookedTourSection;
